import {useState, useEffect} from 'react';
import { httpGet, APIEndpoint, EndpointType } from '../utils/apiService'
import { Order, OrdersResponse } from '../models/OrdersResponse'

const apiURL =  APIEndpoint(EndpointType.MyOrders);


export const useMyOrders = (customerID: string, refreshKey: number) => {
    const [orders, setMyOrders] = useState<Order[]>([])
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)
    
    useEffect(() => {
        if (!customerID) return;
        const url = apiURL + customerID

        setLoading(true)
        httpGet(url)
            .then((data) => {
                try {
                    const myOrdersResponse = data as OrdersResponse;

                    if (myOrdersResponse.status === 'error') {
                        setError(myOrdersResponse.errorMessage)
                        setMyOrders([])
                    } else {
                        if (myOrdersResponse.orders == undefined) {
                            myOrdersResponse.orders = []
                        } else {
                            setMyOrders(myOrdersResponse.orders);
                        }
                    }
                }
                catch(error) {
                    const emptyOrder: Order[] = []
                    setMyOrders(emptyOrder)
                    setError("No orders were found")
                }
            })
            .catch((error) => {
                if (error instanceof Error) {
                    console.log("error contacting service: ", error.message)
                    setError(error.message)
                }
                setMyOrders([])
            })
            .finally(() => setLoading(false))

    }, [customerID, refreshKey]);

    return { orders, loading, error };
};